import { z } from 'zod/v3';

export const UserFollowedDataObjectGroupFormDataSchema = z.object({
  id: z.number(),
  dataObjectGroupId: z.number().optional(),
  dataObjectGroup: z.string().optional(),
  periodSkipCount: z.number().optional(),
});
